import { render } from "./ContractBlock.vue?vue&type=template&id=c851f496"
import script from "./ContractBlock.vue?vue&type=script&lang=js"
export * from "./ContractBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__